import type { ProductionLine } from './api';

const CRITICAL_DIETARY_TAGS = new Set(['SIN_TACC', 'VEGANO']);

/**
 * Client-side mirror of `apps/api`'s `splitByDietaryCriticality`
 * (`modules/production/domain/group-lines.ts`) — `packages/ui`/`apps/web-admin`
 * cannot import `apps/api` code, so the same pure logic lives here by hand,
 * same criterion the rest of this app already applies to Zod schemas.
 * Partitions the same array in two, never copies elements.
 */
export function splitByDietaryCriticality(lines: readonly ProductionLine[]): {
  critical: ProductionLine[];
  general: ProductionLine[];
} {
  const critical: ProductionLine[] = [];
  const general: ProductionLine[] = [];

  for (const line of lines) {
    const target = line.dietaryTags.some((tag) => CRITICAL_DIETARY_TAGS.has(tag))
      ? critical
      : general;
    target.push(line);
  }

  return { critical, general };
}

/** Read-only projection over `snapshot.lines`; never a partition of the snapshot. */
export function groupByServiceType(
  lines: readonly ProductionLine[],
): Map<string, ProductionLine[]> {
  const grouped = new Map<string, ProductionLine[]>();

  for (const line of lines) {
    const bucket = grouped.get(line.serviceType);
    if (bucket === undefined) {
      grouped.set(line.serviceType, [line]);
    } else {
      bucket.push(line);
    }
  }

  return grouped;
}
